import { Controller } from "@hotwired/stimulus"

// A row that scrolls sideways says so: it fades out at an edge with more
// beyond it (the CSS reads data-fade), and brings its chosen item into view.
export default class extends Controller {
  connect() {
    this.update = this.update.bind(this)
    this.element.addEventListener("scroll", this.update, { passive: true })
    this.observer = new ResizeObserver(this.update)
    this.observer.observe(this.element)
    this.update()
  }

  disconnect() {
    this.element.removeEventListener("scroll", this.update)
    this.observer?.disconnect()
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.element
    const start = scrollLeft > 1
    const end = scrollLeft + clientWidth < scrollWidth - 1
    this.element.dataset.fade = [start && "start", end && "end"].filter(Boolean).join(" ")
  }
}
